import { StateSchema } from 'app/providers/StoreProvider';

export const getProposalFilter = (state: StateSchema) =>
    state.orderProposalFilter.filter;

export const getProposalFilterIsActive = (state: StateSchema) =>
    state.orderProposalFilter.filter !== 'All';

export const getProposalFilteredItems = (state: StateSchema) =>
    state.orderProposalFilter.filteredItems;

export const getProposalFilterSellersDataBySeller = (state: StateSchema) =>
    state.orderProposalFilter.filterSellersDataBySeller;

export const getPoEditState = (state: StateSchema) =>
    state.orderProposalFilter.poEditState;

export const hasUnsavedPoChanges = (state: StateSchema) => {
    const poEditState = state.orderProposalFilter.poEditState;
    if (!poEditState?.editingSellerId) {
        return false;
    }
    const tempValue = poEditState.tempPoValue.trim();
    const originalValue = poEditState.originalPoValue.trim();

    if (!tempValue && !originalValue) {
        return false;
    }

    return tempValue !== originalValue;
};

export const isPoBeingEdited = (state: StateSchema) => {
    const poEditState = state.orderProposalFilter.poEditState;
    return !!poEditState?.editingSellerId;
};
